import { object, string } from 'yup'
import type { SearchFilterState } from './types'

export const searchFilterSchema = object({
  searchText: string().max(40),
})

export const validateSearch = (searchFilters: SearchFilterState) =>
  searchFilterSchema.validateSync(searchFilters)
